import { Content } from "@/components/ui/ContentArea";
import { DatosAnioInputDashboard } from "./DatosAnioInputDashboard";

export function EmpresaInputPage() {
	return (
		<Content className="p-5">
			<title>Editar Datos Anuales</title>
			<DatosAnioInputDashboard />
		</Content>
	);
}
